import { IKeHoachTuanActionTypes } from "../../action-types/ke-hoach/IKeHoachTuanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachTuanReducer } from "../../reducer-model/ke-hoach/IKeHoachTuanReducer";
const iniState: IKeHoachTuanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  keHoachTuans: [],
  idKh: 0
};
export const keHoachTuanReducer = (
  state: IKeHoachTuanReducer = iniState,
  action: IKeHoachTuanActionTypes
): IKeHoachTuanReducer => {
  switch (action.type) {
    case "KE_HOACH_TUAN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idKh: action.payload
      };
    case "KE_HOACH_TUAN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachTuans: action.payload,
      };
    case "KE_HOACH_TUAN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KE_HOACH_TUAN_SHOW_QUICK_CREATE": {
      return {
        ...state,
        isShowEditModal: action.payload
      };
    }
    case "KE_HOACH_TUAN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "KE_HOACH_TUAN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "KE_HOACH_TUAN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "KE_HOACH_TUAN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "KE_HOACH_TUAN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "KE_HOACH_TUAN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };

    default:
      return state;
  }
};
